module.exports = __webpack_public_path__ + "static/media/ipfs-logo.6afbd7b3.png";